import { STRING_TIPO_DE_IMAGEN } from "../const/string-const";

export function createEmptyProductoForm() {
    return {
        id: 0,
        idCategoriaProducto: "",
        slug: "",
        codigo: "",
        nombre: "",
        descripcion: "",
        precioOriginal: "",
        porcentajeDescuento: 0,
        precio: "",
        idMoneda: "",
        tipoImagenPrincipal: STRING_TIPO_DE_IMAGEN.image,
        imagenPrincipal: "",
        tipoImagenes: STRING_TIPO_DE_IMAGEN.image,
        imagenes: [],
        rating: "",
        cantidadDisponiblePublico: 0,
        cantidadDisponiblePrivado: 0,
        idBadge: "",
        publico: 1,
        habilitado: 1,
    };
}

export function parseImagenesField(imagenes) {
    if (Array.isArray(imagenes)) return imagenes;
    if (typeof imagenes === "string" && imagenes.trim()) {
        try {
            const parsed = JSON.parse(imagenes);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    }
    return [];
}

export function calculatePrecioConDescuento(precioOriginal, porcentajeDescuento) {
    const original = Number(precioOriginal);
    const discount = Number(porcentajeDescuento) || 0;
    if (precioOriginal === "" || precioOriginal == null || Number.isNaN(original)) {
        return null;
    }
    const precio = original * (1 - discount / 100);
    return precio.toFixed(2);
}

export function findSelectOption(options, value) {
    if (!value || !Array.isArray(options)) return null;
    return options.find((item) => item.value === value) ?? null;
}
